import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import staticURL from 'lib/staticURL';
import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';

export default function ComposeOverEntryBanner(): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.INFO}
      text="Learn how to review AI updates to this entry."
      action={{actionType: InlineBannerActionType.ACCORDION}}
      supportingInfo={
        <div className={css(styles.supportingInfoWrapper)}>
          <ul className={css(styles.bulletList)}>
            <li>
              To see what changed, open the <strong>History panel</strong> to view and compare past versions.
              Currently, all changes are <strong>attributed to you</strong>.
            </li>
            <li>
              To undo changes, click <strong>Reset to version</strong> on any past version.
            </li>
            <li>
              Remember that AI can make mistakes, and that updates may happen outside of your current view.
            </li>
          </ul>
          <img
            src={staticURL('/static/img/reset-to-version.png')}
            alt="Screenshot showing the Reset to version button in the History panel"
            className={css(styles.screenshot)}
          />
        </div>
      }
    />
  );
}

const styles = StyleSheet.create({
  supportingInfoWrapper: {
    width: '100%',
  },
  bulletList: {
    margin: '4px 0 0',
    paddingLeft: 20,
  },
  screenshot: {
    display: 'block',
    marginTop: 8,
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 300,
    borderRadius: 4,
  },
});
